// extracted by mini-css-extract-plugin
export default {"title":"styles_title__ZdCej","icon":"styles_icon__g9bIt","titleDarkTheme":"styles_titleDarkTheme__h0gm+"};